<template>
  <div class="wapTop"  :style="{display: this.$store.state.scrollHeight?'none':'block'}">
    <!-- wap-view_Start -->
    <el-row class="hidden-sm-and-up" :style="{ marginTop: '80px',borderBottom:'2px white solid'}" >
      <div class=""></div>
      <div class="wapTopFlex">
        <div>
<!--          <i-->
<!--            class="el-icon-s-unfold"-->
<!--            @click="drawer = true"-->
<!--            :style="{ fontSize: '40px', cursor: ' pointer', color: '#fff' }"-->
<!--          ></i>-->
          <img  @click="drawer = true" src="../../static/assets/img/menu.png" height="40" width="40" alt="西雅图桃桃高端私人定制_menu" class="el-icon-s-unfold">
        </div>
        <div class="textRight fontSize20 pro-title">
          <img src="../../static/assets/img/logo.png" width="252" height="82" alt="西雅图桃桃高端私人定制" class="logoClass">
<!--          {{h_title}}-->
<!--          <router-link to="/register" class="c-white">-->
<!--            <b>{{h_title}}</b>-->
<!--          </router-link>-->
        </div>
        <div class="textRight">
          <span class="hide"
            >西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所</span
          >
        </div>
      </div>
    </el-row>

    <el-drawer
      :title="h_title"
      :visible.sync="drawer"
      direction="ltr"
      custom-class="customClass"
      size="50%"
      :modal="false"
      :with-header="false"
    >
      <div class="textLeft">
        <div class="left_menu_cur size-13">
<!--          {{h_title}}-->
        </div>
        <dl>
          <template>
            <dd :key="0">
              <router-link to="/"
                ><i class="el-icon-s-home"></i>首页</router-link
              >
            </dd>
<!--            <dd :key="9">-->
<!--              <router-link to="/wellreceived"-->
<!--                ><i class="el-icon-s-data"></i>好评管理</router-link-->
<!--              >-->
<!--            </dd>-->

            <dd
              v-for="(item, index) in tabs"
              :key="index + 1"
              :index="index + 1"
            >
              <router-link :to="{ name: 'princess', query: { id: index + 1 } }"
                ><i class="el-icon-s-data"></i>{{ item.title }}</router-link
              >
            </dd>
          </template>
        </dl>
      </div>
    </el-drawer>
    <!-- wap-view_End -->

    <el-row
      type="flex"
      justify="space-between"
      class="topDiv col hidden-sm-and-down"
    >
      <el-col :span="6" :offset="2" class="textLeft"
        ><a href="tel:425-999-6494 " title="联系号码"
          >tel:{{ $store.state.contactConfig.phone }}
        </a></el-col
      >
      <el-col class="size-13">{{ h_title }}</el-col>
      <el-col :span="6">
        <span class="hide"
          >西雅图找小姐,约炮,找美女,找妹妹,西雅图约炮,西雅图找美女,西雅图私人会所,桃桃私人会所,西雅图会所</span
        >
        <el-dropdown @command="handleCommand" class="">
          <span class="el-dropdown-link">
            | 多语言<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="中文">中文</el-dropdown-item>
            <el-dropdown-item command="English">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <el-row type="flex" class="hidden-sm-and-down win-top" >
      <el-col :span="4" :offset="2" class="el-lineheight win-top textLeft">
        <router-link to="/"
          ><h1 class="logo hidden-sm-and-up">首页</h1>
        </router-link>
      </el-col>
      <el-col :span="12">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          background-color="#1a1a1a"
          text-color="#cfcfcf"
          active-text-color="#f787c9"
        >
          <template>
            <el-menu-item @click="handleSelect('-1')" :key="0">
              <a><i class="el-icon-s-home"></i>首页</a>
            </el-menu-item>
<!--            <el-menu-item @click="handleSelect('-2')" :key="9">-->
<!--              <a>好评管理</a>-->
<!--            </el-menu-item>-->
            <el-menu-item
              v-for="(item, index) in tabs"
              :key="index + 1"
              @click="handleSelect(index + 1)"
            >
              <a>{{ item.title }}</a>
            </el-menu-item>
          </template>
        </el-menu>
      </el-col>
      <el-col :span="4" class="el-lineheight textRight win-top"> </el-col>
    </el-row>

    <el-row class="wap_foot hidden-sm-and-up" type="flex" justify="center">
      <el-col :span="12"
        ><a href="tel:425-999-6494"><i class="el-icon-phone"></i></a
      ></el-col>
      <el-col :span="12"
        ><a href="sms:425-999-6494"><i class="el-icon-message"></i></a
      ></el-col>
    </el-row>
  </div>
</template>

<script type="text/javascript">
let _th;
import PrincessView from "../page/princess";
import auth from "../auth";
export default {
  name:'Head',
  data() {
    return {
      h_title:"西雅图桃桃高端私人定制",
      tabs: [],
      routesIndex: 2,
      drawer: false,
      tokenBool: false,
      loggedIn: auth.loggedIn(),
      navInfo: this.NAVINFO,
      activeIndex: "home",
      currURL: {
        name: this.$router.currentRoute.name,
        path: this.$router.currentRoute.path
      },
      searchData: {
        name: null,
        age: null,
        sex: null,
        interst: null
      },
      webIcon: {
        Tel: require("../assets/icon/an.jpg"),
        email: require("../assets/icon/icon_other.png"),
        lang: require("../assets/icon/icon_other.png"),
        langIs: false
      },
      classList: {
        customClass: {
          backgroundColor: "#1a1a1a"
        }
      },
      searchForm: [
        {
          type: "Input",
          label: "姓名",
          prop: "name",
          width: "100%",
          placeholder: "请输入姓名..."
        }
      ],
      searchHandle: [{ label: "查询", type: "primary", handle: () => "" }]
    };
  },
  components: {
    auth,
    PrincessView
  },
  mounted() {
    _th = this;
    try {
      let token = this.$localStorage.getItem("userId");
      if (token != null) {
        _th.$store.state.princess = JSON.parse(token);
        _th.tabs = JSON.parse(token);
      }
    } catch (e) {
      console.log(e);
    }
    this.initFun();
  },
  methods: {
    initFun() {
      fetch("https://api2.seattletaotao.com/api/princess/getList", {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(result => {
          return result.json();
        })
        .then(res => {
          if (res.code == 1) {
            let d = [];
            d = res.data;
            if (d.length > 1) {

              d.map(o => {
                o.url = o.urlimage;
                let arr = o.picimages.split(",");
                let temparr = [];
                for (let i = 0; i < arr.length; i++) {
                  temparr.push("https://api2.seattletaotao.com" + arr[i]);
                }
                o.pic = temparr;
                try{
                  o.pricelist = JSON.parse(o.pricejson);
                }catch(e){
                  o.pricelist = null;
                }
              });
              d.sort(this.compare("sortid"));
              //console.log(d);

              _th.$localStorage.getItem("userId", JSON.stringify(d));
              _th.$sesionStorage.setItem("userId", JSON.stringify(d));
              _th.$store.state.princess = d;
              _th.tabs = d;
            }
          }
        })
        .catch(e => {
          // _th.$router.go(0)
        });

      fetch("https://api2.seattletaotao.com/api/princess/getsite", {
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(result => {
        return result.json();
      })
      .then(res => {
        if (res.code == 1) {
          let d = [];
          d = res.data;
          if (d.phone) {
            _th.$localStorage.getItem("siteConfig", JSON.stringify(d));
            _th.$store.state.contactConfig = d;
            _th.$store.state.tabs[0].value = d.wechat;
            _th.$store.state.tabs[2].value = d.whatsapp;
            _th.$store.state.tabs[3].value = d.short;
          }
        }
      })
      .catch(e => {
        // _th.$router.go(0)
      });
    },
    compare(prop) {
      return function (obj1, obj2) {
        var val1 = obj1[prop];
        var val2 = obj2[prop];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
        }
        if (val1 < val2) {
            return -1;
        } else if (val1 > val2) {
            return 1;
        } else {
            return 0;
        }
    }

    },

    handleSelect(i) {
      let k = i.toString();
      switch (k) {
        case "-1":
          this.$router.push("/welcome");
          this.activeIndex = k;
          break;
        case "-2":
          this.$router.push("/wellreceived");
          this.activeIndex = k;
          break;
        default:
          this.$router.push({ path: "/princess", query: { id: i } });
          this.activeIndex = k;
          break;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    handleCommand(command) {
      this.$message("成功切换" + command);
    },
    changeLang() {
      console.log("切换语言！");
      this.webIcon.langIs = !this.webIcon.langIs;
    }
  },
  created() {
    auth.onChange = loggedIn => {
      this.loggedIn = loggedIn;
    };
  }
};
</script>

<style scoped type="text/scss">
/deep/ .el-drawer__body dl dd a{
  border-bottom: 1px solid #f4f4f4;
  border-top: 0px solid #f4f4f4;
}

.c-white {
  color: #cfcfcf;
}
.size-13 {
  font-size: 1.3rem;
}
.logo {
  margin: 0;
  padding: 0;
}
.pro-title{
  color: white;
  font-weight: bold;
  letter-spacing: 0.2rem;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
.wapTop {
  position: relative;
}
.win-top{
  background-color: #1a1a1a;
}
.logoClass{
  position: absolute;
  top: -44px;
  left: 20vw;
  z-index: 1002;
}
.wapTopFlex {
  position: absolute;
  top: -40px;
  z-index: 1002;
  display: flex;
  justify-content: space-between;
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#1a1a1a),
      to(#1f1f1f)
  );
  background-image: linear-gradient(to bottom, #1a1a1a, #1f1f1f);
  width: 100%;
  border-bottom: 1px white solid;
}
.wapTopFlex > div {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.topDiv {
  font-size: 14px;
  color: white;
  padding-bottom: 6px;
  padding-top: 6px;
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#1a1a1a),
      to(#1f1f1f)
  );
  background-image: linear-gradient(to bottom, #1a1a1a, #1f1f1f);
}
.topDiv a {
  color: white;
}
.topDiv a:hover {
  color: #dc143c;
}
.topDiv .textLeft a {
  font-size: 20px;
}
.el-dropdown-link {
  color: white;
}
.el-menu-item,
.el-submenu__title,
.el-menu-item a {
  font-size: 16px;
}
.wap_foot {
  position: fixed;
  bottom: 0;
  z-index: 9999;
  background-color: #99a9bf;
  width: 100%;
  background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(#1a1a1a),
      to(#1f1f1f)
  );
  background-image: linear-gradient(to bottom, #1a1a1a, #1f1f1f);
}

.hide {
  display: none;
}
.wap_foot i {
  font-size: 30px;
  color: white;
}
.wap_foot span {
  font-size: 20px;
  color: white;
  cursor: pointer;
}
.left_menu_cur {
  color: white;
  font-size: 14px;
  line-height: 30px;
  padding: 8px 10px 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue